// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-with-postfix[data-v-f0b9a524]{padding-bottom:14px;position:relative;font-style:normal;font-weight:400;font-size:18px;line-height:24px}.input-with-postfix #postfix[data-v-f0b9a524]{color:var(--q4s-neutral-500);position:absolute;left:30px}.input-with-postfix #hidden-div[data-v-f0b9a524]{width:auto;display:inline-block;visibility:hidden;position:fixed;overflow:auto}", ""]);
// Exports
module.exports = exports;
